import React, { useState, useEffect } from 'react';
import { Modal, Text, TextArea } from '@getpingback/realeza';
import CloseIcon from '@material-ui/icons/Close';
import ContentEditor from '../../EducationCourse/components/ContentEditor';
import { IconButton, Button, TextField, Select, MenuItem } from '@material-ui/core';

const NewPartnerModal = ({ isOpen, onClose, onSubmit, isUpdating, dataForm }) => {
  const [formValues, setFormValues] = useState({
    id: dataForm ? dataForm.id : null,
    slug: '',
    name: '',
    description: '',
    content: '',
    categories: [],
    image: '',
    languages: [],
    site: '',
    contactEmail: '',
    partnerType: '',
    discountCode: '',
    discountDetails: '',
    discountUrl: '',
  });

  useEffect(() => {
    if (dataForm && isUpdating) {
      setFormValues({
        id: dataForm.id,
        slug: dataForm.slug,
        name: dataForm.name,
        description: dataForm.description,
        content: dataForm.content,
        categories: dataForm.categories,
        image: dataForm.image,
        languages: dataForm.languages,
        site: dataForm.site,
        contactEmail: dataForm.contactEmail,
        partnerType: dataForm.partnerType,
        discountCode: dataForm.discountCode,
        discountDetails: dataForm.discountDetails,
        discountUrl: dataForm.discountUrl,
      });
    }
  }, [dataForm]);

  return (
    <Modal onClose={onClose} isOpen={isOpen} className="saasPlans__modal">
      <div className="saasPlans__modal__top">
        <h2>{isUpdating ? 'Update Partner' : 'New Partner'}</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <div className="saasPlans__modal__content">
        <div>
          <TextField
            id="standard-basic"
            label="Partner Name"
            value={formValues.name}
            onChange={e => setFormValues({ ...formValues, name: e.target.value })}
            required
            variant="outlined"
          />

          <TextField
            id="standard-basic"
            label="Plan slug"
            value={formValues.slug}
            onChange={e => setFormValues({ ...formValues, slug: e.target.value })}
            required
            variant="outlined"
            disabled={isUpdating}
          />

          <TextField
            id="standard-basic"
            label="Description"
            value={formValues.description}
            onChange={e => setFormValues({ ...formValues, description: e.target.value })}
            required
            variant="outlined"
          />
        </div>

        <div>
          <TextField
            id="standard-basic"
            label="Partner Site"
            value={formValues.site}
            onChange={e => setFormValues({ ...formValues, site: e.target.value })}
            required
            variant="outlined"
          />

          <TextField
            id="standard-basic"
            label="Partner Image"
            value={formValues.image}
            onChange={e => setFormValues({ ...formValues, image: e.target.value })}
            required
            variant="outlined"
          />

          <TextField
            id="standard-basic"
            label="Partner Email"
            value={formValues.contactEmail}
            onChange={e => setFormValues({ ...formValues, contactEmail: e.target.value })}
            required
            variant="outlined"
          />
        </div>

        <ContentEditor
          content={formValues.content}
          setContent={value => setFormValues({ ...formValues, content: value })}
          isRequired={true}
        />

        <div className="saasPlans__modal__content__selects">
          <div className="saasPlans__modal__content__selects--item">
            <Text color="gray" intensity={300} size={12}>
              Categories
            </Text>
            <Select
              multiple
              variant="outlined"
              value={formValues.categories}
              defaultValue={formValues.categories}
              onChange={e => setFormValues({ ...formValues, categories: e.target.value })}
              required
            >
              <MenuItem value="ai-tools">AI Tools</MenuItem>
              <MenuItem value="paid-ads">Paid Ads</MenuItem>
              <MenuItem value="web-services">Web Services</MenuItem>
            </Select>
          </div>

          <div className="saasPlans__modal__content__selects--item">
            <Text color="gray" intensity={300} size={12}>
              Partner Type
            </Text>
            <Select
              variant="outlined"
              value={formValues.partnerType}
              defaultValue={formValues.partnerType}
              onChange={e => setFormValues({ ...formValues, partnerType: e.target.value })}
              required
            >
              <MenuItem value="service">Service</MenuItem>
              <MenuItem value="discount">Discount</MenuItem>
            </Select>
          </div>

          <div className="saasPlans__modal__content__selects--item">
            <Text color="gray" intensity={300} size={12}>
              Languages
            </Text>
            <Select
              multiple
              variant="outlined"
              value={formValues.languages}
              defaultValue={formValues.languages}
              onChange={e => setFormValues({ ...formValues, languages: e.target.value })}
              required
            >
              <MenuItem value="pt-BR">Portuguese</MenuItem>
              <MenuItem value="en-US">English</MenuItem>
              <MenuItem value="es-ES">Spanish</MenuItem>
            </Select>
          </div>
        </div>

        {formValues.partnerType === 'discount' && (
          <div>
            <TextField
              id="standard-basic"
              label="Discount Code"
              value={formValues.discountCode}
              onChange={e => setFormValues({ ...formValues, discountCode: e.target.value })}
              required
              variant="outlined"
            />

            <TextField
              id="standard-basic"
              label="Discount Details"
              value={formValues.discountDetails}
              onChange={e => setFormValues({ ...formValues, discountDetails: e.target.value })}
              required
              variant="outlined"
            />

            <TextField
              id="standard-basic"
              label="Discount URL"
              value={formValues.discountUrl}
              onChange={e => setFormValues({ ...formValues, discountUrl: e.target.value })}
              required
              variant="outlined"
            />
          </div>
        )}

        <Button
          style={{ margin: '20px', backgroundColor: '#249c0d', color: '#fff' }}
          variant="contained"
          onClick={() => onSubmit(formValues)}
        >
          {isUpdating ? 'Update' : 'Create'}
        </Button>
      </div>
    </Modal>
  );
};

export default NewPartnerModal;
